const assertNever = (x: never): Error => new Error(`Unexpected type: ${x}`);

const isTruthy = <T>(x: T | null | undefined): x is T => !!x;

const isNumber = (x: any): x is number => Number.isFinite(x);

const isDefined = <T>(x: T | null | undefined): x is T => x !== null && x !== undefined;

export { assertNever, isTruthy, isNumber, isDefined };
